import { render, staticRenderFns } from "./BusinessDetail.vue?vue&type=template&id=416ea18d&"
import script from "./BusinessDetail.vue?vue&type=script&lang=js&"
export * from "./BusinessDetail.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports